import { render } from "./Cell.vue?vue&type=template&id=627a2fea&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"

import "./Cell.vue?vue&type=style&index=0&id=627a2fea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627a2fea"]])

export default __exports__